'use strict';

var _ = require('underscore');

var shitSizes = [
  {"value": "Small", "key": 18},
  {"value": "Medium", "key": 20},
  {"value": "Large", "key": 22},
  {"value": "X Large", "key": 24},
  {"value": "XX Large","key": 26},
  {"value": "XXX Large","key": 28}
];

module.exports = {

    getShitSize: function(shit_size) {
        return _.filter(shitSizes, function(shit) { return shit.key === shit_size; })[0].value;
    },

    isEmail: function(val) {
        return val && val.indexOf && val.indexOf('@') > -1 && val.indexOf('.') > -1;
    },

    helpfulHelper: function() {
        return "help";
    },

    getParameterByName: function(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },

};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/utils.js
 ** module id = 247
 ** module chunks = 0 1 6 7 8 9
 **/